import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-layout-document-single-two',
  templateUrl: './layout-document-single-two.component.html',
  styleUrls: ['./layout-document-single-two.component.scss']
})
export class LayoutDocumentSingleTwoComponent  implements OnInit
{
  @Input() inputData: any;
  constructor() { }

  ngOnInit()
  {
    console.log(this.inputData, 'inputData');

  }

}

